import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({
    label: {
        fontWeight: "bold",
        color: "#002F36",
        minWidth: 155,
        "&.Mui-focused": {
            color: "#002F36"
        }
    },
    radioButtonGroup: {
        minWidth: 200
    },
    radioButton: {
        marginRight: 20,
        marginLeft: 0,
        "& .MuiRadio-colorSecondary.Mui-checked": {
            color: "#3474b4"
        }   
    }
});